module.exports = __webpack_public_path__ + "media/favicons/favicon-734e0a5c15c4b2e7f098ee476f543f34.svg";